import React from "react";
import { Query } from "react-apollo";
import { Layout, Spin } from "antd";

import Breadcrumb from "../Components/Navigation/Breadcrumb";

import ServiceRequest from "../Components/Services/ServiceRequest";

import OrderProgress from "../Components/Orders/OrderProgress";
import OrderDetailComponent from "../Components/Orders/OrderDetailComponent";
import OrderResponse from "../Components/Orders/OrderResponse";
import OrderCompleted from "../Components/Orders/OrderCompleted";
import ModalPaidStatus from "../Components/Orders/ModalPaidStatus";

import Messenger from "../Components/Comments/Messenger";

import GetOrder from "../GraphQL/Query/GetOrder";
import UserContext from "../Contexts/UserContext";

const { Content } = Layout;

const renderDetail = (orderId, order, status, profile) => {
  switch (status) {
    case "completed":
      return <OrderCompleted order={order} orderId={orderId} />;
    case "created":
    case "collectingData":
      return <ServiceRequest order={order} orderId={orderId} />;
    case "sent":
      return <OrderResponse order={order} orderId={orderId} user={profile} />;
    default:
      return <OrderDetailComponent order={order} orderId={orderId} />;
  }
};

const OrderDetail = ({ match, history }) => {
  const orderId = match.params.orderId;
  return (
    <React.Fragment>
      <UserContext.Consumer>
        {({ profile }) => (
          <Query
            query={GetOrder}
            variables={{ orderId, userId: profile.username }}
            fetchPolicy="cache-and-network"
          >
            {({ loading, error, data }) => {
              // console.log(loading, error, data);
              if (loading && !data.getOrder) return <Spin />;
              if (error) return <p>Error :(</p>;
              const { getOrder: order = {} } = data;

              if (!order) {
                return <p>Error al recuperar la orden.</p>;
              }
              const { status, paid } = order;
              return (
                <Content style={{ background: "#fff", padding: "4rem 3rem" }}>
                  {!paid && <ModalPaidStatus history={history} />}
                  <Breadcrumb />
                  <OrderProgress status={status} />
                  {renderDetail(orderId, order, status, profile)}
                </Content>
              );
            }}
          </Query>
        )}
      </UserContext.Consumer>
      <Messenger orderId={orderId} />
    </React.Fragment>
  );
};

export default OrderDetail;



// WEBPACK FOOTER //
// ./src/Pages/OrderDetail.js